import {
  Component,
  ElementRef,
  Input,
  Output,
  ViewChild,
  EventEmitter,
  OnInit,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import { CountryWithCallingCode, countriesWithCallingCodes } from "./countries";
import { fromEvent } from "rxjs/observable/fromEvent";
import { delay, map, startWith, takeUntil, tap } from "rxjs/operators";
import { Observable, Subject } from "rxjs";

@Component({
  selector: "mobile-phone-input",
  templateUrl: "./mobile-phone-input.component.html",
  styleUrls: ["./mobile-phone-input.component.scss"],
})
export class MobilePhoneInputComponent implements OnInit, OnDestroy {
  @Input() data: string;
  @Input() langIsoCode: string;

  @Output() onMobilePhoneChange = new EventEmitter();

  readonly countryList = countriesWithCallingCodes as CountryWithCallingCode[];

  selectedCountry: CountryWithCallingCode;
  selectedDialingCode: string;
  isCountryListShown: boolean = false;

  telInputValue: string;

  countryList$: Observable<CountryWithCallingCode[]>;

  private destroy$ = new Subject<void>();

  @ViewChild("telInputEl") telInputEl: ElementRef;
  @ViewChild("dialingCodeInputEl") dialingCodeInputEl: ElementRef;

  constructor() {}

  ngOnInit(): void {
    let prop = "name";
    if (
      this.langIsoCode &&
      (this.langIsoCode.toLowerCase() === "de" ||
        this.langIsoCode.toLowerCase() === "ch")
    ) {
      prop = "de_name";
    }
    this.countryList.sort((a, b) => {
      if (a[prop] < b[prop]) {
        return -1;
      }
      if (a[prop] > b[prop]) {
        return 1;
      }
      return 0;
    });
    // TODO: Check when this should be used
    // this.langIsoCode ? this.langIsoCode : "CH";
    const countryCode = "CH";
    this.selectedCountry = this.countryList.find((x) => x.code === countryCode);
    this.selectedDialingCode = this.selectedCountry.dialling_code;
  }

  onDialingCodeInputInput() {
    this.countryList$ = fromEvent(
      this.dialingCodeInputEl.nativeElement,
      "keyup"
    ).pipe(
      takeUntil(this.destroy$),
      map((e: KeyboardEvent) => {
        const value = (e.target as HTMLInputElement).value;
        const filteredCountryList = this.countryList.filter(
          (item) =>
            item.name.toLowerCase().includes(value.toLowerCase()) ||
            item.dialling_code.toLowerCase().includes(value.toLowerCase())
        );
        this.isCountryListShown = !!filteredCountryList.length;
        return filteredCountryList;
      }),
      startWith(this.countryList),
      delay(0)
    );
  }

  onTelInputInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/\D/g, "");
    this.telInputValue = inputElement.value;
  }

  onSelectCountry(value: CountryWithCallingCode): void {
    this.selectedCountry = value;
    this.selectedDialingCode = value.dialling_code;
    this.telInputEl.nativeElement.focus();
    this.isCountryListShown = false;
    this.countryList$ = Observable.of(this.countryList);
  }

  onShowCountryList(): void {
    this.isCountryListShown = !this.isCountryListShown;
    this.countryList$ = Observable.of(this.countryList);
  }

  onTelInputFocusOut() {
    const regex = /^[0-9]+$/;
    if (!this.telInputValue && !regex.test(this.telInputValue)) return;
    const currentTelNumber = `${this.selectedCountry.dialling_code}${this.telInputValue}`;
    this.onMobilePhoneChange.emit(currentTelNumber);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/components/mobile-phone-input/mobile-phone-input.component.ts